<template>
  <div class="storenotecard">
    <div
      :style="{
        background: datas.backColor,
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <section
        v-if="datas.styleType !== 3"
        :class="[
          datas.styleType === 1 || datas.styleType === 4
            ? 'goods_list_con1'
            : datas.styleType === 5
            ? 'goods_list_con5'
            : 'goods_list_con3',
        ]"
        class="goods_list_con"
        style="display: flex"
      >
        <div class="goods_item_con" @click="handleClickImg(datas)">
          <!-- 视频图片 -->
          <div class="goods_img_con">
            <img
              draggable="false"
              :src="datas.firstImgUrl ? datas.firstImgUrl : defaultImg"
              alt=""
            />
          </div>

          <!-- 内容 -->
          <div
            :class="[
              {
                goods_info_con4: datas.styleType === 4 || datas.styleType === 5,
              },
              'goods_info_con',
            ]"
            :style="{ 'background-color': datas.titleBgColor }"
          >
            <!-- 名称 -->
            <div
              class="name_con"
              :style="{
                color: datas.wordColorTitle,
                'font-size': datas.wordSizeTitle + 'px',
                'font-weight': datas.isBoldTitle ? 'bold' : 'normal',
                'font-style': datas.isTiltTitle ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineTitle
                  ? 'underline'
                  : 'none',
              }"
            >
              {{ datas.title }}
            </div>
            <div
              :style="{
                color: datas.wordColorDesc,
                'font-size': datas.wordSizeDesc + 'px',
                'font-weight': datas.isBoldDesc ? 'bold' : 'normal',
                'font-style': datas.isTiltDesc ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineDesc ? 'underline' : 'none',
              }"
            >
              {{ datas.descTitle }}
            </div>
          </div>
        </div>
        <div
          v-if="datas.styleType == 2 || datas.styleType == 5"
          class="goods_item_con"
          @click="handleClickImg(datas.link2Obj)"
        >
          <!-- 视频图片 -->
          <div class="goods_img_con">
            <img
              draggable="false"
              :src="datas.secondImgUrl ? datas.secondImgUrl : defaultImg"
              alt=""
            />
          </div>

          <!-- 内容 -->
          <div
            :class="[
              { goods_info_con4: datas.styleType === 5 },
              'goods_info_con',
            ]"
            :style="{ 'background-color': datas.titleBgColor2 }"
          >
            <div
              class="name_con"
              :style="{
                color: datas.wordColorTitle2,
                'font-size': datas.wordSizeTitle2 + 'px',
                'font-weight': datas.isBoldTitle2 ? 'bold' : 'normal',
                'font-style': datas.isTiltTitle2 ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineTitle2
                  ? 'underline'
                  : 'none',
              }"
            >
              {{ datas.title2 }}
            </div>
            <div
              :style="{
                color: datas.wordColorDesc2,
                'font-size': datas.wordSizeDesc2 + 'px',
                'font-weight': datas.isBoldDesc2 ? 'bold' : 'normal',
                'font-style': datas.isTiltDesc2 ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineDesc2
                  ? 'underline'
                  : 'none',
              }"
            >
              {{ datas.descTitle2 }}
            </div>
          </div>
        </div>
      </section>

      <section
        v-if="datas.styleType === 3"
        class="goods_list_con goods_list_con2"
      >
        <div class="goods_item_con" @click="handleClickImg(datas)">
          <!-- 视频图片 -->
          <div class="goods_img_con">
            <img
              draggable="false"
              :src="datas.firstImgUrl ? datas.firstImgUrl : defaultImg"
              alt=""
            />
          </div>

          <div
            :class="['goods_info_con']"
            :style="{ 'background-color': datas.titleBgColor }"
          >
            <!-- 名称 -->
            <div
              class="name_con"
              :style="{
                color: datas.wordColorTitle,
                'font-size': datas.wordSizeTitle + 'px',
                'font-weight': datas.isBoldTitle ? 'bold' : 'normal',
                'font-style': datas.isTiltTitle ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineTitle
                  ? 'underline'
                  : 'none',
              }"
            >
              {{ datas.title }}
            </div>
            <div
              :style="{
                color: datas.wordColorDesc,
                'font-size': datas.wordSizeDesc + 'px',
                'font-weight': datas.isBoldDesc ? 'bold' : 'normal',
                'font-style': datas.isTiltDesc ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineDesc ? 'underline' : 'none',
              }"
            >
              {{ datas.descTitle }}
            </div>
          </div>
        </div>
        <div class="goods_item_con" @click="handleClickImg(datas.link2Obj)">
          <!-- 视频图片 -->
          <div class="goods_img_con">
            <img
              draggable="false"
              :src="datas.secondImgUrl ? datas.secondImgUrl : defaultImg"
              alt=""
            />
          </div>

          <div
            :class="['goods_info_con']"
            :style="{ 'background-color': datas.titleBgColor2 }"
          >
            <div
              class="name_con"
              :style="{
                color: datas.wordColorTitle2,
                'font-size': datas.wordSizeTitle2 + 'px',
                'font-weight': datas.isBoldTitle2 ? 'bold' : 'normal',
                'font-style': datas.isTiltTitle2 ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineTitle2
                  ? 'underline'
                  : 'none',
              }"
            >
              {{ datas.title2 }}
            </div>
            <div
              :style="{
                color: datas.wordColorDesc2,
                'font-size': datas.wordSizeDesc2 + 'px',
                'font-weight': datas.isBoldDesc2 ? 'bold' : 'normal',
                'font-style': datas.isTiltDesc2 ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLineDesc2
                  ? 'underline'
                  : 'none',
              }"
            >
              {{ datas.descTitle2 }}
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
import { handleScanCode } from "@/utils";
export default {
  name: "Storenotecard",
  props: {
    datas: Object,
  },
  data() {
    return {
      defaultImg: require("@/assets/images/defaultPic2.png"),
    };
  },

  created() {},

  methods: {
    handleClickImg(item) {
      if (!item) return;
      if (item.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (item.linkUrl) {
        window.location.href = item.linkUrl;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.storenotecard {
  position: relative;

  .goods_list_con {
    background: #fff;

    .goods_item_con {
      position: relative;
      width: 100%;
      // box-shadow: 2px 5px 5px 5px rgba(213, 213, 213, 0.5);
    }
    &.goods_list_con1 {
      .goods_img_con {
        height: 368px;
      }
      .goods_item_con {
        margin-right: 0;
      }
    }
    &.goods_list_con5 {
      .goods_img_con {
        height: 360px;
      }
      .goods_item_con {
        margin-right: 10px;
        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
    &.goods_list_con3 {
      flex-wrap: wrap;
      .goods_item_con {
        flex: 1;
        margin-right: 10px;
        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
    &.goods_list_con2 {
      .goods_item_con {
        display: flex;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
        .goods_img_con {
          width: 360px;
          height: 248px;
        }
        .goods_info_con {
          flex: 1;
        }
      }
    }
    .goods_img_con {
      height: 248px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .goods_info_con {
      padding: 18px;
      .name_con {
        font-size: 16px;
        margin-bottom: 10px;
      }
    }
    .goods_info_con4 {
      position: absolute;
      bottom: 0;
      width: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
